(function () {
  'use strict';

  angular.module('eclipseApp.reserveDevice')
    .config(['$stateProvider', function ($stateProvider) {

      $stateProvider.state('reservedevice', {
        // name: 'reservedevice',
        url: '/reservedevice',
        title: "reserveDevice",
        controller: 'uteReserveDeviceCtrl',
        templateUrl: 'modules/reserveDevice/reservedevice.html',
        data: {
          authRequired: true
        },
        resolve: {
          getAccountDetails: ['authenticationGuardService',
            '$q',
            'commonService',
            '$rootScope',
            function (authenticationGuardService, $q, commonService, $rootScope) {
              return authenticationGuardService.canActivatePromise().then(function (loggedIn) {
                return loggedIn ? commonService.getAccountDetails($rootScope.userInfo.accounts) : $q.defer().promise;
              });
            }]
        }

      });
    }]);

})();
